// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"324c38bb","209":"bff89858","457":"64088f51","472":"a57b130b","498":"5aa6b4e4","551":"aff4b7c5","627":"b5248700","661":"0aca6c74","796":"3fcacb58","851":"ab4adb41","898":"2de56755"}[chunkId] + ".chunk.js";
};